import { motion } from "framer-motion";
import { Users, Briefcase, ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";

const fleet = [
  {
    name: "Cadillac Escalade",
    tag: "The Flagship",
    img: "https://images.unsplash.com/photo-1683778547049-8d969766b441",
    imgClass: "object-center brightness-100",
    pax: "Up to 6 guests",
    bags: "6 large cases",
    copy: "The definitive American statement. Commanding presence, cathedral-quiet cabin.",
    large: true,
  },
  {
    name: "Chevrolet Suburban Z71",
    tag: "The Workhorse",
    img: "/suburban-z71.webp",
    imgClass: "object-[center_60%] brightness-100",
    pax: "Up to 7 guests",
    bags: "7 large cases",
    copy: "Rugged capability meets executive comfort — built for the long Hamptons haul.",
    large: false,
  },
];

export const Fleet = () => (
  <section id="fleet" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-28 lg:py-40">
    <Reveal>
      <p className="overline mb-5">01 — The Fleet</p>
      <h2 className="font-serif text-4xl lg:text-6xl tracking-tight max-w-2xl leading-tight">
        Two vehicles. Zero compromise on the arrival.
      </h2>
    </Reveal>

    <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-6">
      {fleet.map((v, i) => (
        <Reveal
          key={v.name}
          delay={i * 0.15}
          className={v.large ? "md:col-span-7" : "md:col-span-5"}
        >
          <motion.div
            whileHover="hover"
            className="group relative bg-surface border border-white/10 overflow-hidden h-full"
            data-testid={`fleet-card-${i}`}
          >
            <div className="relative overflow-hidden aspect-[16/10]">
              <motion.img
                variants={{ hover: { scale: 1.06 } }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                src={v.img}
                alt={v.name}
                className={`w-full h-full object-cover ${v.imgClass} grayscale-[30%] group-hover:grayscale-0 transition-[filter] duration-700`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-surface via-transparent to-transparent" />
              <span className="absolute top-5 left-5 overline text-gold">{v.tag}</span>
            </div>
            <div className="p-7 lg:p-9">
              <div className="flex items-start justify-between">
                <h3 className="font-serif text-3xl lg:text-4xl">{v.name}</h3>
                <ArrowUpRight className="w-6 h-6 text-[#8A8A8A] group-hover:text-gold group-hover:rotate-45 transition-transform duration-500" />
              </div>
              <p className="mt-4 text-[#8A8A8A] font-light max-w-md">{v.copy}</p>
              <div className="mt-7 flex gap-8 border-t border-white/10 pt-5">
                <span className="flex items-center gap-2 text-sm text-[#F5F5F0]">
                  <Users className="w-4 h-4 text-gold" /> {v.pax}
                </span>
                <span className="flex items-center gap-2 text-sm text-[#F5F5F0]">
                  <Briefcase className="w-4 h-4 text-gold" /> {v.bags}
                </span>
              </div>
            </div>
          </motion.div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Fleet;
